<template>
  <div class="min-h-screen flex flex-col">
    <TopBar />
    <main class="pt-6 pb-6 flex-grow bg-gray-100">
      <div class="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div class="sm:max-w-full md:max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto">

          <!-- WIZARD PROGRESS BAR -->
          <div class="mb-8">
            <div class="flex items-center justify-center">
              <!-- Step 1: Questions -->
              <div class="flex items-center">
                <div class="flex items-center justify-center w-8 h-8 rounded-full font-bold" :class="step >= 1 ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'">1</div>
                <div class="ml-2 font-medium" :class="step >= 1 ? 'text-gray-700' : 'text-gray-500'">Step 1: Questions</div>
              </div>
              <!-- Connector -->
              <div class="flex-1 h-1 mx-2" :class="step > 1 ? 'bg-blue-500' : 'bg-gray-300'"></div>
              <!-- Step 2: Answers -->
              <div class="flex items-center">
                <div class="flex items-center justify-center w-8 h-8 rounded-full font-bold" :class="step >= 2 ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'">2</div>
                <div class="ml-2 font-medium" :class="step >= 2 ? 'text-gray-700' : 'text-gray-500'">Step 2: Answers</div>
              </div>
              <!-- Connector -->
              <div class="flex-1 h-1 mx-2" :class="step > 2 ? 'bg-blue-500' : 'bg-gray-300'"></div>
              <!-- Step 3: Instructions -->
              <div class="flex items-center">
                <div class="flex items-center justify-center w-8 h-8 rounded-full font-bold" :class="step >= 3 ? 'bg-blue-500 text-white' : 'bg-gray-300 text-gray-500'">3</div>
                <div class="ml-2 font-medium" :class="step >= 3 ? 'text-gray-700' : 'text-gray-500'">Step 3: Instructions</div>
              </div>
            </div>
          </div>

          <!--
            The <slot> is where Vue Router (via App.vue) will render the actual page
            component like QuestionsText.vue or AnswersText.vue.
          -->
          <slot></slot>

        </div>
      </div>
    </main>
    <footer class="bg-gray-200 py-4">
      <p class="text-center">© 2024 EasyMarks AI</p>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import TopBar from './TopBar.vue'

const route = useRoute()
const step = computed(() => route.meta.step || 1)
</script>
